import { render, staticRenderFns } from "./AppCadastroAluno.vue?vue&type=template&id=416b554c&"
import script from "./AppCadastroAluno.vue?vue&type=script&lang=js&"
export * from "./AppCadastroAluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports